<script>
    export let title;
    export let content;

    let open = false;

    function toggle(){
        open = !open;
    }
</script>

<div class="toggle" class:open on:click={toggle}>
    <div class="toggle-title">
        <h3>{title}</h3>
    </div>
    <div class="toggle-content">
        {@html content}
    </div>
</div>


<style>
    .toggle .toggle-content {
        display: none;
    }
    .toggle.open .toggle-content{
        display: block;
    }

    .toggle {
        padding: 20px;
        cursor: pointer;
        max-width: 750px;
        margin: auto;
        background: #fff;
        border-radius: 0px;
        margin-bottom: 20px;
    }

    h3 {
        margin: 0;
    }

    .toggle-content {
        text-align: left;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        color: #859DB7;
        font-size: 14px;
    }
    .toggle-content :global(p:last-child){
        margin-bottom: 0;
    }
</style>